import React, { useState } from "react";
import { FiMapPin, FiShare2, FiHeart, FiArrowUpRight } from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./ProjectGallery.css";
import whatsappLink from "../../utils/whatsappLink";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import Lightbox from 'react-image-lightbox'; // Importing the lightbox library
import 'react-image-lightbox/style.css'; // Import the styles for the lightbox

export default function ProjectGallery({
  images = [],
  status,
  title,
  location,
  startingPrice,
  tag,
  id,
  number,
}) {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1); // Track current image index
  const [isOpen, setIsOpen] = useState(false); // Track if lightbox is open

  const addClick = async (type) => {
    const data = {
      url: apis().lisitingAddClick + "?id=" + id,
      method: "PUT",
    };
    await httpAction(data);
    if (type === "brousher") {
      window.location.href = whatsappLink(
        number,
        "Hi plese send me details of this project",
        window.location.href
      );
    } else {
      window.location.href = whatsappLink(
        number,
        "Hi there i want to visit this project",
        window.location.href
      );
    }
  };

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true); // Open the lightbox when the image is clicked
  };

  const closeLightbox = () => {
    setIsOpen(false); // Close the lightbox
  };

  return (
    <section className="pgg">
      <div className="pgg__bg" />
      <div className="pgg__overlay" />

      <div className="container pgg__container">
        <div className="pgg__wrap">
          <div className="pgg__left">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              spaceBetween={12}
              slidesPerView={1}
              className="pgg__swiper"
            >
              {images.map((src, idx) => (
                <SwiperSlide key={idx}>
                  <div className="pgg__slide">
                    <img
                      className="pgg__img"
                      src={src}
                      alt={`Project ${idx + 1}`}
                      onClick={() => openLightbox(idx)} // Open the lightbox when clicked
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="pgg__float">
              <span className="pgg__badge">{status}</span>
              {tag ? <span className="pgg__tag">{tag}</span> : null}
            </div>

            <div className="pgg__actions">
              <button className="pgg__iconBtn" type="button" title="Save">
                <FiHeart />
              </button>
              <button className="pgg__iconBtn" type="button" title="Share">
                <FiShare2 />
              </button>
            </div>
          </div>

          <div className="pgg__right">
            <div className="pgg__price">
              <span className="pgg__priceLabel">Starting</span>
              <span className="pgg__priceVal">{startingPrice}</span>
            </div>

            <h1 className="pgg__title">{title}</h1>

            <div className="pgg__loc">
              <FiMapPin />
              <span>{location}</span>
            </div>

            <p className="pgg__sub">
              Premium high-rise living with modern amenities, smart layouts, and
              a location designed for long-term value.
            </p>

            <div className="pgg__ctaRow">
              <button onClick={() => addClick('brousher')} className="pgg__btn pgg__btn--primary" type="button">
                Request Brochure <FiArrowUpRight />
              </button>
              <button onClick={() => addClick('visit')} className="pgg__btn pgg__btn--ghost" type="button">
                Book Site Visit
              </button>
            </div>

            <div className="pgg__note">
              Transparent plans, verified documentation, and guided investment
              options.
            </div>
          </div>
        </div>
      </div>

      <div className="pgg__fade" />

      {/* Lightbox Modal */}
      {isOpen && (
        <Lightbox
          mainSrc={images[currentImageIndex]}
          nextSrc={images[(currentImageIndex + 1) % images.length]}
          prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setCurrentImageIndex((currentImageIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setCurrentImageIndex((currentImageIndex + 1) % images.length)
          }
        />
      )}
    </section>
  );
}